import React from 'react';
import {
  number, arrayOf, shape, string, func,
} from 'prop-types';
import { withI18n } from '@active/react-utils/i18n/LocaleContext';
import { currency } from '../../../../../../../Currency';
import { dateTime } from '../../../../../../../DateTime';
import PaymentPlanItem from './PaymentPlanItem';

const PaymentPlanDetailInfo = ({
  installmentPaymentInfoList,
  i18n,
  locale,
}) => {
  if (installmentPaymentInfoList.length === 0) {
    return null;
  }

  const titleItem = [
    i18n('checkout.lib.components.text.amountDue'),
    i18n('checkout.lib.components.text.amountPaid'),
    i18n('checkout.lib.components.text.dueDate'),
  ];
  return (
    <div className="payment-plan-info">
      <PaymentPlanItem itemList={titleItem} className="payment-plan-info__title"/>
      <div className="payment-plan-info__content">
        {
          installmentPaymentInfoList.map(({
            remainingBalance, currencyCode,
            paidAmount, dueDate,
          }, index) => {
            const i18nDateTime = dateTime({ date: dueDate, locale });
            const i18nAmountDue = currency({ amount: remainingBalance + paidAmount, code: currencyCode, locale });
            const i18nPaidAmount = currency({ amount: paidAmount, code: currencyCode, locale });

            const itemList = [
              i18nAmountDue,
              i18nPaidAmount,
              i18nDateTime,
            ];
            return <PaymentPlanItem itemList={itemList} key={index} className="payment-plan-info__item"/>;
          })
        }
      </div>
    </div>
  );
};

PaymentPlanDetailInfo.propTypes = {
  i18n: func.isRequired,
  locale: string,
  installmentPaymentInfoList: arrayOf(shape({
    remainingBalance: number,
    currencyCode: string,
    paidAmount: number,
    dueDate: shape({
      time: number,
      timeZoneOffset: number,
    }),
  })),
};

PaymentPlanDetailInfo.defaultProps = {
  installmentPaymentInfoList: [],
};

export default withI18n(PaymentPlanDetailInfo);
